"use client"

import WatsonApi from "../backends/WatsonApi";
import useSWR from "swr";
import SchoolBlocksLoadingIndicator from "../components/utilities/SchoolBlocksLoadingIndicator";
import AlertComponent from "../components/blocks/SchoolBlocks/Notification/AlertComponent";
import styles from "./styles/ViewNotificationPage.module.scss";
import NotificationManager from "../components/notifications/NotificationManager";

export default function ViewNotificationPage() {

    const {data, isLoading} = useSWR("fetch-notification", async () => {
        const path_array = window.location.pathname.split("/")
        const notification_id = path_array[path_array.length - 1]
        const orgId = path_array[path_array.length - 2]
        try {
            const client = await WatsonApi();
            const response = await client.apis.organizations.organizations_alerts_read({
                organization_pk: orgId,
                id: notification_id,
            });
            return JSON.parse(response.data);
        } catch (e) {
            NotificationManager.error("Notification not found.")
            return {
                message: "Notification not found! It may have been deleted.",
            }
        }
    }, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
    })

    return <div className={styles.container}>
        {isLoading ? <div style={{textAlign: "center"}}>
            <SchoolBlocksLoadingIndicator fill={"var(--fontColor)"} />
        </div> : <AlertComponent key={data.id} message={data.message} />}
    </div>
}